import {
  createRouter,
  createWebHashHistory,
} from 'vue-router'

const routes = [
  // 路由的默认路径
  { path: '/', redirect: '/home' },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/committeeLiving/home/'),
    meta: {
      title: '委员会客厅'
    },
    children: []
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/committeeLiving/home/detail'),
    meta: {
      title: '值班详情'
    },
    children: []
  },
  {
    path: '/addMsg',
    name: 'addMsg',
    component: () => import('@/views/committeeLiving/addMsg/add'),
    meta: {
      title: '我要留言'
    },
    children: []
  },
  {
    path: '/msgDetail',
    name: 'msgDetail',
    component: () => import('@/views/committeeLiving/msgDetail/'),
    meta: {
      title: '留言详情'
    },
    children: []
  },
  {
    path: '/Collection',
    name: 'Collection',
    component: () => import('@/views/Collection/'),
    meta: {
      title: '文史资料库'
    }
  },
  {
    path: '/Collection-detail',
    name: 'Collection-detail',
    component: () => import('@/views/Collection/detail'),
    meta: {
      title: '文史资料库详情'
    }
  },
  {
    path: '/internetPolitics',
    name: 'internetPolitics',
    component: () => import('@/views/internetPolitics/'),
    meta: {
      title: '网络议政'
    }
  },
  {
    path: '/internetPolitics-detail',
    name: 'internetPolitics-detail',
    component: () => import('@/views/internetPolitics/detail'),
    meta: {
      title: '网络议政详情'
    }
  },
  {
    path: '/remoteNegotiation',
    name: 'remoteNegotiation',
    component: () => import('@/views/remoteNegotiation/'),
    meta: {
      title: '远程协商'
    }
  },
  {
    path: '/remoteNegotiation-detail',
    name: 'remoteNegotiation-detail',
    component: () => import('@/views/remoteNegotiation/detail'),
    meta: {
      title: '远程协商详情'
    }
  }
]

// 创建路由对象
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {//判断是否有标题
    document.title = to.meta.title
    if (document.getElementById('navbarName')) {
      document.getElementById('navbarName').innerHTML = to.meta.title
    }
  }
  next()  //执行进入路由，如果不写就不会进入目标页
})

export default router